import { render, staticRenderFns } from "./KeycloakDetails.vue?vue&type=template&id=a326fadc&scoped=true"
import script from "./KeycloakDetails.vue?vue&type=script&lang=js"
export * from "./KeycloakDetails.vue?vue&type=script&lang=js"
import style0 from "./KeycloakDetails.vue?vue&type=style&index=0&id=a326fadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a326fadc",
  null
  
)

export default component.exports